
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/formEle/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-form-ele-demo-base","pages-pages-reference-form-ele-demo-extend"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/formEle/index.md?type=demo')
};